import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IImageHistoryModel } from '../models/requestModels'

export class GetImageHistoryApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/productImage/listImageHistoryByCode',
      requesterInfo,
    })
  }
  public async historyByCode(request: string): Promise<IImageHistoryModel[]> {
    return await this.postAsync<IImageHistoryModel[]>(request)
  }
}
